import React, { useEffect, useRef, useState } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import css from '../cards/SellerCard.APP_TARGET.scss';
import { FormattedMessage as Translation, FormattedDate } from 'react-intl';
import withConfig from 'HOCs/withConfig/withConfig';
import { convertToAbsoluteImageURI } from 'Helpers/images';
import { fileNames } from 'Constants/imageUrls';
import { SVG_EXT, X } from 'Constants/images';
import { Avatar } from 'panamera-react-ui';
import MemberSince from 'Components/MemberSince/MemberSince';
import { getAuthorisedDealerTxt } from 'Selectors/config';
import Icon from 'Components/ThematicIcon/ThematicIcon';
import { Link } from 'react-router-dom';
import VerifiedAccounts from '../../Profile/VerifiedAccounts/VerifiedAccounts.mobile';
import { isCocoFofoUser, isCocoUser, isFofoUser } from 'Helpers/item';
import FollowButton from 'Components/Profile/FollowButton/FollowButton';
import EllipsisToolTip from 'Components/EllipsisToolTip/EllipsisToolTip';
import { DATA_AUT_IDS } from 'Constants/constants';
import ImageGallery from 'Components/ImageGallery/ImageGallery';
import ImageWrapper from 'Components/ImageWrapper/ImageWrapper';
import MembershipTagV1 from 'Components/MembershipTagV1/MembershipTagV1';
import { checkIfPremiumUser, checkIfSuperUser } from 'Helpers/premiumUser';

export const LOGO_TYPE = {
    LARGE: 'large',
    SMALL: 'small',
    NONE: 'none'
};

export const SellerBrand = ({
    olxAutosLogo,
    isApprovedDealer,
    isVerifiedSeller,
    postedDate,
    userName,
    userImage,
    user,
    config,
    locality,
    isMyItem,
    showMemberSince,
    authorisedDealerTxt,
    avatar,
    profileLink,
    direction,
    sellerProfilePage,
    adpvTxnRevamp,
    loggedUser,
    isCurrentlyOpen,
    coverImages
}) => {
    const staticAsseturl = config.get('staticAssets');
    const invertedBrandLogo = config.get('invertedBrandLogo');
    const theme = config.get('theme', 'id');
    const cocoFofoUser = isCocoFofoUser(user);
    const isClassified = true;
    const olxAutosLogoImg = olxAutosLogo !== LOGO_TYPE.NONE && <img
        className={ css.logoImg }
        style={ { maxHeight: 35 } }
        src={ convertToAbsoluteImageURI(invertedBrandLogo, SVG_EXT, staticAsseturl, X, '', theme) }
        alt="olx autos logo"
    />;
    const isMyOwnAd = user?.id !== loggedUser?.id;
    const cocoUser = isCocoUser(user);
    const fofoUser = isFofoUser(user);

    const renderFollowBtn = user => (<FollowButton userName={ user?.name } userId={ user?.id } isIconFlavour={ false } size={ 'xsmall' } className={ css.followButton } />);
    const revampedCOCO = adpvTxnRevamp && (olxAutosLogo === LOGO_TYPE.LARGE);

    const [isOverflowing, setIsOverflowing] = useState(false);
    const contentRef = useRef(null);

    useEffect(() => {
        const content = contentRef.current;

        if (content) {
            setIsOverflowing(content.scrollHeight > content.clientHeight);
        }
    }, []);

    const getUserName = () => {
        return (<div className={ classNames(css.verifiedSellerContainer, { [css.updatedSellerContainer]: revampedCOCO }) } data-aut-id="verifiedProfileCard">
            {userName && (
                isClassified ? (
                    <span className={ css.sellerName } data-aut-id={ DATA_AUT_IDS.SELLER_NAME }>
                        <EllipsisToolTip tooltip={ true } tooltipText={ userName }>
                            {userName}
                        </EllipsisToolTip>
                    </span>
                ) : (
                    <span className={ css.sellerName } data-aut-id={ DATA_AUT_IDS.SELLER_NAME }>
                        {userName}
                    </span>
                )
            )}

            {
                isVerifiedSeller && <>
                    <span className={ classNames(css.dealerTag, css.verfiedSeller) } data-aut-id="verified-seller">
                        <Translation id="dealerVerifiedSeller" />
                    </span>
                    <img
                        data-aut-id="verified-seller-img"
                        className={ css.verifiedUserImage }
                        src={ convertToAbsoluteImageURI(fileNames.VERIFIED_USER, SVG_EXT, staticAsseturl, X, '', theme) }
                        alt="verified user"
                    />
                </>
            }
        </div>);
    };

    const renderAutosLogo = () => {
        return !adpvTxnRevamp && (olxAutosLogo === LOGO_TYPE.LARGE) && <figure className={ css.cocoLogo } data-aut-id="renderAutosLogo" >
            {olxAutosLogoImg}
            {sellerProfilePage && isClassified && <div className={ css.avatarInfo } >
                <div className={ css.modernSellerName } >
                    { locality ? `${locality},` : ''} {userName || ''}
                </div>
            </div>}
        </figure>;
    };

    const renderFofoSellerLogo = () => {
        return (olxAutosLogo === LOGO_TYPE.SMALL || isApprovedDealer) && (
            <div className={ css.fofoContainer } data-aut-id="fofoSellerLogo">
                {
                    olxAutosLogo === LOGO_TYPE.SMALL && <figure className={ css.fofoLogo } data-aut-id="small-brand-logo">
                        {olxAutosLogoImg}
                    </figure>
                }
                {
                    isApprovedDealer && <span data-aut-id="dealer-tag" className={ css.dealerTag }>
                        {authorisedDealerTxt}
                    </span>
                }
            </div>
        );
    };

    const renderUserInfo = () => {
        switch (true) {
            case cocoUser:
                return renderAutosLogo();

            case fofoUser:
                return renderFofoSellerLogo();

            default:
                return getUserName();
        }
    };

    const onAboutInfoClick = () => {
        if (document) {
            const content = document.querySelector('#aboutInfo');

            // document.querySelector('#aboutDropdown').style.display = 'none';
            setIsOverflowing(false);

            content.classList.toggle(css.expanded);
        }
    };

    return (
        <React.Fragment>
            <>
                <div className={ css.modernProfileHeader }>
                    <div className={ css.midHeader }>
                        { userImage
                            && <div className={ css.userImage } data-aut-id="user-image">
                                {coverImages?.length > 0 && <ImageGallery
                                    showDots={ true }
                                    showFavouriteButton
                                    imageSize="375"
                                    imageHeight="134"
                                    dotSize={ 8 }
                                    showSliderArrows={ false }
                                    showIndex={ false }
                                    align="right"
                                    dotsAlign="center"
                                    stretchImage={ true }
                                    images={ coverImages }
                                />}
                                <div className={ coverImages?.length > 0 && css.avatar }>
                                    <ImageWrapper
                                        fileName={ userImage }
                                        className={ css.image }
                                    />
                                </div>

                            </div>
                        }
                    </div>
                </div>

                <div className={ classNames(css.nameAndLocality, { [css.isPremium]: checkIfPremiumUser(user?.subscription_info?.type) }, { [css.isSuperDealer]: checkIfSuperUser(user?.subscription_info?.type) }) }>
                    {
                        (userName || isVerifiedSeller) && isClassified && sellerProfilePage && (
                            renderUserInfo()
                        )
                    }
                    <div style={ { display: 'flex', alignItems: 'center' } } >
                        {cocoFofoUser && !sellerProfilePage && <div className={ css.soldBy } data-aut-id="sold-by">
                            <Translation id={ isMyItem ? 'postBy' : 'soldBy' } />
                            {
                                revampedCOCO && <figure data-aut-id="brand-logo" className={ css.brandLogo }>
                                    {olxAutosLogoImg}
                                </figure>
                            }
                        </div>}
                        {
                            cocoFofoUser && !sellerProfilePage && renderAutosLogo()
                        }
                    </div>
                    {
                        (userName || isVerifiedSeller) && !sellerProfilePage && (
                            isClassified && !cocoFofoUser
                                ? <div className={ css.profileCard } data-aut-id="profileCard">
                                    <Link title="profileCard" to={ profileLink } rel="nofollow" className={ css.avatarWrapper }>
                                        <Avatar image={ avatar } diameter="68px" className={ css.avatar } />
                                    </Link>
                                    <div className={ css.profileData }>
                                        <Link title={ userName } to={ profileLink } rel="nofollow">
                                            <div className={ css.profileTitle } >{userName}</div>
                                            <span className={ css.arrow }>
                                                <Icon icon="arrowRight" direction={ direction } size={ 16 } />
                                            </span>
                                        </Link>
                                    </div>
                                </div>

                                : getUserName()
                        )
                    }
                    {
                        !sellerProfilePage && renderFofoSellerLogo()
                    }
                    {
                        !isClassified && !isMyItem && postedDate && (
                            <div data-aut-id="itemCreationDate" className={ css.postedDate }>
                                <Translation id="postedOn" />
                                {' : '}
                                <FormattedDate
                                    value={ new Date(postedDate) }
                                    year="numeric"
                                    month="2-digit"
                                    day="2-digit"
                                />
                            </div>
                        )
                    }
                    {!adpvTxnRevamp && !sellerProfilePage && cocoFofoUser && locality && <div className={ css.localityMX } data-aut-id="locality">{locality}</div> }

                    {isClassified && sellerProfilePage
                        && <div className={ css.midInfoSection }>

                            {user?.about && <div className={ css.about }>
                                <div ref={ contentRef } className={ css.aboutInfo } id="aboutInfo">
                                    {user.about}
                                </div>
                                {isOverflowing && (
                                    <div onClick={ onAboutInfoClick } id="aboutDropdown">
                                        <Icon data-aut-id="arrowDown" theme={ theme } icon="arrowDown" size={ 16 } />
                                    </div>
                                )}
                            </div>}

                            <div className={ css.verifyMemberSice }>
                                <div className={ css.verifyUser }>
                                    <Icon data-aut-id="tickInShield" theme={ theme } icon="tickInShield" size={ 16 } color="greenBase" overrideClassName={ css.greenIcon } />
                                    <Translation id="userVerifiedWith" />
                                    <div className={ css.verifyUserIcons }>
                                        <VerifiedAccounts user={ user } socialIconType={ 'profile' } isClassified={ true } className={ css.icon } />
                                    </div>
                                </div>

                                { showMemberSince
                            && <div className={ css.members }>
                                <div className={ css.memberSince } data-aut-id="member-since">
                                    <MemberSince user={ user } type="caption" isClassified={ isClassified } />
                                </div>
                            </div>
                                }
                            </div>

                            <div className={ css.buttons }>
                                <MembershipTagV1
                                    type={ user?.subscription_info?.type || '' }
                                    containerClassName={ css.tagContainerClassName }
                                    textClassName={ css.textClassName }
                                    iconClassName={ css.iconClassName }
                                />
                                <div>
                                    {((isClassified && sellerProfilePage && isMyOwnAd) || true) && renderFollowBtn(user)}
                                </div>
                            </div>

                            {isCurrentlyOpen && <div className={ css.status }><Translation id="openNow" /></div>}

                        </div>
                    }
                </div>
            </>
        </React.Fragment>
    );
};

SellerBrand.propTypes = {
    olxAutosLogo: PropTypes.oneOf([LOGO_TYPE.LARGE, LOGO_TYPE.SMALL, LOGO_TYPE.NONE]),
    isApprovedDealer: PropTypes.bool,
    isVerifiedSeller: PropTypes.bool,
    postedDate: PropTypes.string,
    userName: PropTypes.string,
    userImage: PropTypes.string,
    user: PropTypes.object,
    config: PropTypes.object,
    locality: PropTypes.string,
    isMyItem: PropTypes.bool,
    showMemberSince: PropTypes.bool,
    authorisedDealerTxt: PropTypes.string,
    avatar: PropTypes.string,
    profileLink: PropTypes.string,
    direction: PropTypes.oneOf(['ltr', 'rtl']),
    sellerProfilePage: PropTypes.bool,
    loggedUser: PropTypes.object,
    adpvTxnRevamp: PropTypes.bool,
    coverImages: PropTypes.array,
    isCurrentlyOpen: PropTypes.bool
};

SellerBrand.defaultProps = {
    avatar: '',
    profileLink: '',
    olxAutosLogo: LOGO_TYPE.NONE,
    isApprovedDealer: false,
    isVerifiedSeller: false,
    sellerProfilePage: false,
    postedDate: '',
    userName: '',
    userImage: '',
    user: {},
    locality: '',
    isMyItem: false,
    showMemberSince: false,
    userLogged: {},
    adpvTxnRevamp: false,
    operatingDetailsObject: {}
};

const mapStateToProps = state => ({
    authorisedDealerTxt: getAuthorisedDealerTxt(state)
});

export default compose(
    withConfig,
    connect(mapStateToProps)
)(SellerBrand);
